'use es6';

import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CustomToolbarMessage() {
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "bottom",
    use: "longform",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tinymceThemes.customToolbar.helpLinkToolTip"
    }),
    children: /*#__PURE__*/_jsx(UILink, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tinymceThemes.customToolbar.helpLink"
      })
    })
  });
}